import BaseParser from './BaseParser';
import { TOOL_TYPE } from './ToolType';

/**
 * MermaidParser - Parser para diagramas Mermaid
 *
 * Convierte patrones [MERMAID_DIAGRAM]...[/MERMAID_DIAGRAM] a parts específicos
 * para renderizar con ChatMermaidCard en lugar de usar Markdown.js
 */
class MermaidParser extends BaseParser {
  constructor() {
    super('Mermaid', 1); // Prioridad media
  }

  getPatterns() {
    return [/\[MERMAID_DIAGRAM\](.*?)\[\/MERMAID_DIAGRAM\]/gs];
  }

  extractMatches(content) {
    const matches = [];
    const pattern = this.getPatterns()[0];
    let match;

    // Reset regex
    pattern.lastIndex = 0;

    while ((match = pattern.exec(content)) !== null) {
      let mermaidCode = match[1].trim();
      let title = '';

      // Intentar extraer título del código si existe comentario al inicio
      const titleMatch = mermaidCode.match(/^%%\s*title:\s*(.+)\n/);
      if (titleMatch) {
        title = titleMatch[1].trim();
        // Remover el comentario del título del código
        mermaidCode = mermaidCode.replace(/^%%\s*title:\s*.+\n/, '');
      }

      matches.push({
        index: match.index,
        length: match[0].length,
        type: TOOL_TYPE.MERMAID_DIAGRAM,
        originalMatch: match[0],
        mermaidCode: mermaidCode,
        title: title,
      });
    }

    return matches;
  }

  convertContent(content) {
    // Ya no convertimos a markdown, dejamos el contenido original
    // para que extractMatches pueda procesarlo
    return content;
  }

  createPart(match) {
    return {
      type: TOOL_TYPE.MERMAID_DIAGRAM,
      mermaidCode: match.mermaidCode,
      title: match.title,
    };
  }
}

export default MermaidParser;
